import { render, staticRenderFns } from "./AppMobileTabs.vue?vue&type=template&id=8791ac82"
import script from "./AppMobileTabs.vue?vue&type=script&lang=js"
export * from "./AppMobileTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports